import { ROLE_PLATFORM_HIXME_ADMIN } from '@hixme/role-policy'
import authOnEnter from 'enrollment-platform/authOnEnter'
import AdminPortalGate from 'enrollment-platform/rbac/AdminPortalGate'
import { abilityOnEnter } from 'enrollment-platform/rbac/abilityOnEnter'
import { RbacActions, RbacSubjects } from 'enrollment-platform/rbac/constants'
import AccessControl from './AccessControl'
import RoleDetail from './pages/Roles/RoleDetail'
import { ACCESS_CONTROL } from './paths'

const AccessControlRoute = {
  path: ACCESS_CONTROL,
  component: AdminPortalGate,
  onEnter(
    _nextState: unknown,
    replace: (pathname: string) => void,
    callback: (err?: unknown) => void
  ) {
    // Role check first (existing), then DB ability: Read on
    // PermissionManagement (the page also self-gates on this). Read lets
    // viewers in; mutating controls are gated on Manage inside the page.
    authOnEnter({
      allowedRoles: [ROLE_PLATFORM_HIXME_ADMIN],
      callback: (err?: { status: number; message: string }) =>
        err
          ? callback(err)
          : abilityOnEnter({
              action: RbacActions.Read,
              subject: RbacSubjects.PermissionManagement,
              replace,
              callback,
            }),
    })
  },
  indexRoute: {
    component: AccessControl,
  },
  childRoutes: [
    {
      path: 'roles/:roleId',
      component: RoleDetail,
    },
  ],
}

export default AccessControlRoute
